<template>
  <div class="star_wrap">
    <template v-if="bTotal">
      <div class="thsize">
        <div class="title">
          综合评分
        </div>
        <div class="star_icon">
          <van-rate
            v-model="nScore"
            disabled
            allow-half
            void-icon="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/star/no.png"
            icon="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/star/star.png"
          />
        </div>

        <div class="scroe">{{ nScore }}分</div>
      </div>
    </template>
    <ul class="ul_wrap">
      <li v-for="item in aStar" :key="item.evaluationType">
        <div class="title">
          {{ item.evaluationTypeName }}
        </div>
        <div class="star_icon">
          <van-rate
            v-model="item.score"
            :disabled="bDisable"
            @change="onChange(item)"
            allow-half
            void-icon="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/star/no.png"
            icon="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/star/star.png"
          />
        </div>
        <div class="scroe">
          {{ onScore(item.score) }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "star",
  props: {
    bDisable: {
      type: Boolean,
      default: false,
    },
    bTotal: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Number,
      default: 2.5,
    },
    aStar: {
      type: Array,
      default: () => {
        return [
          { evaluationType: 0, score: 0, evaluationTypeName: "培训课程" },
          { evaluationType: 1, score: 0, evaluationTypeName: "院校环境" },
          { evaluationType: 2, score: 0, evaluationTypeName: "师资规模" },
          { evaluationType: 3, score: 0, evaluationTypeName: "服务态度" },
        ];
      },
    },
  },
  data() {
    return {
      nScore: 2.5,
    };
  },
  watch: {
    total(val, oldValue) {
      this.nScore = val;
    },
  },
  methods: {
    onChange(item) {
      this.$emit("change", item);
    },
    onScore(num) {
      let objNum = {
        1: "有点差",
        2: "一般",
        3: "还不错",
        4: "很满意",
        5: "非常满意",
      };
      num = parseInt(Math.ceil(num));
      return objNum[num];
    },
  },
};
</script>
<style lang="less" scoped>
.star_wrap {
  font-family: PingFangSC-Regular, PingFang SC;
  padding: 0 30px 0 30px;
  .thsize {
    display: flex;
    align-items: center;
    padding: 42px 0 46px;
    border-bottom: 1px solid #eaeaea;
    .scroe {
      color: #333;
      font-size: 32px;
    }
  }
  .title {
    font-size: 30px;
    color: #333333;
    line-height: 42px;
  }
  .star_icon {
    display: flex;
    align-items: center;
    margin: 0 27px;
    /deep/ .van-rate__icon--half{
      width:0.6em;
    }
    /deep/.van-icon__image {
      width: 1.3em;
      height: 1.3em;
    }
    /deep/ .van-rate__item:not(:last-child){
      margin-right: 5px;
    }
  }
  .scroe {
    font-size: 26px;
    font-weight: 400;
    color: #666666;
    line-height: 37px;
    margin-left: 12px;
  }
  .ul_wrap {
    padding-top: 34px;
  }
  li {
    display: flex;
    align-items: center;
    font-weight: 400;
    margin-bottom: 25px;
    margin-right: 9px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
